import { render, staticRenderFns } from "./NewProjectHeader.vue?vue&type=template&id=433a1397&scoped=true"
import script from "./NewProjectHeader.vue?vue&type=script&lang=js"
export * from "./NewProjectHeader.vue?vue&type=script&lang=js"
import style0 from "./NewProjectHeader.vue?vue&type=style&index=0&id=433a1397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a1397",
  null
  
)

export default component.exports